import { render, staticRenderFns } from "./PostTipping.vue?vue&type=template&id=339dbdc2&"
import script from "./PostTipping.vue?vue&type=script&lang=ts&"
export * from "./PostTipping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports